import * as React from 'react';
import {FC} from 'react';
import {Chat, IChatProps} from '../Chat/Chat';
import {IMenuOption, Menu} from '../Menu/Menu';
import {Wrapper} from '../Wrapper/Wrapper';


interface IUserProps extends Partial<IChatProps> {
    selected: boolean;
    menu: IMenuOption[];
    expandable?: boolean;
}


export const User: FC<IUserProps> = ({selected, menu, expandable, ...props}) => {
    return (
        <Wrapper selected={selected} expandable={expandable}>
            <Chat {...props}/>
            {Menu(menu)}
        </Wrapper>
    );
};